import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/entradas',
    name: 'rota-entradas',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Entradas',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Entradas',
      icon: 'sign-in-alt',
    },
    component: () => import(/* webpackChunkName: "entradas" */ '../views/entradas/Entradas.vue'),
  },
  {
    path: '/administrativo/entrada/cadastro',
    name: 'rota-entradas-cadastro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Lançamento de entrada',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "entradas" */ '../views/entradas/cadastro/EntradasCadastro.vue'),
  },
]
